<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2c"><a id="page_v"></a>Contents</h2>
<p class="toc1"><a href="#/xhtml/fm01"><em>Preface</em></a></p>
<p class="toc1"><a href="#/xhtml/fm02"><em>Author’s Note</em></a></p>
<p class="toc1"><a href="#/xhtml/fm03"><em>Acknowledgements</em></a></p>
<p class="toc"> </p>
<p class="toc2"><a href="#/xhtml/fm04">Introduction: Facing Oblivion</a></p>
<p class="toc"><a href="#/xhtml/chapter01"><span class="tc">1</span> ‘What’s the Use of a W.C. without a Seat?’</a></p>
<p class="toc"><a href="#/xhtml/chapter02"><span class="tc">2</span> The Road to Scotland</a></p>
<p class="toc"><span href="#/xhtml/chapter03" title="Link target outside of Sample"><span class="tc">3</span> ‘I Chose Dundee’</span></p>
<p class="toc"><span href="#/xhtml/chapter04" title="Link target outside of Sample"><span class="tc">4</span> A Seat for Life?</span></p>
<p class="toc"><span href="#/xhtml/chapter05" title="Link target outside of Sample"><span class="tc">5</span> Vote as You Pray</span></p>
<p class="toc"><span href="#/xhtml/chapter06" title="Link target outside of Sample"><span class="tc">6</span> Enter, Clementine</span></p>
<p class="toc"><span href="#/xhtml/chapter07" title="Link target outside of Sample"><span class="tc">7</span> ‘Not at Home’</span></p>
<p class="toc"><span href="#/xhtml/chapter08" title="Link target outside of Sample"><span class="tc">8</span> Our Man in Dundee</span></p>
<p class="toc"><span href="#/xhtml/chapter09" title="Link target outside of Sample"><span class="tc">9</span> The Peers versus the People</span></p>
<p class="toc"><span href="#/xhtml/chapter10" title="Link target outside of Sample"><span class="tc">10</span> The Strike before Christmas</span></p>
<p class="toc"><span href="#/xhtml/chapter11" title="Link target outside of Sample"><span class="tc">11</span> Home Rule</span></p>
<p class="toc"><span href="#/xhtml/chapter12" title="Link target outside of Sample"><span class="tc">12</span> An Activist Victorious</span></p>
<p class="toc"><span href="#/xhtml/chapter13" title="Link target outside of Sample"><span class="tc">13</span> The Policeman, the Pilot and the Prohibitionist</span></p>
<p class="toc"><span href="#/xhtml/chapter14" title="Link target outside of Sample"><span class="tc">14</span> War</span></p>
<p class="toc"><span href="#/xhtml/chapter15" title="Link target outside of Sample"><span class="tc">15</span> On the Front Line</span></p>
<p class="toc"><span href="#/xhtml/chapter16" title="Link target outside of Sample"><span class="tc">16</span> The Home Front</span></p>
<p class="toc"><span href="#/xhtml/chapter17" title="Link target outside of Sample"><span class="tc">17</span> ‘Shells versus Booze’</span></p>
<p class="toc"><span href="#/xhtml/chapter18" title="Link target outside of Sample"><span class="tc">18</span> Winning the Peace</span></p>
<p class="toc"><span href="#/xhtml/chapter19" title="Link target outside of Sample"><span class="tc">19</span> Revolution</span></p>
<p class="toc"><span href="#/xhtml/chapter20" title="Link target outside of Sample"><span class="tc">20</span> Resolution</span></p>
<p class="toc"><span href="#/xhtml/chapter21" title="Link target outside of Sample"><span class="tc">21</span> Clementine’s Campaign</span></p>
<p class="toc"><span href="#/xhtml/chapter22" title="Link target outside of Sample"><span class="tc">22</span> The Final Round</span></p>
<p class="toc"><a id="page_vi"></a><span href="#/xhtml/chapter23" title="Link target outside of Sample"><span class="tc">23</span> Last Orders</span></p>
<p class="toc"><span href="#/xhtml/chapter24" title="Link target outside of Sample"><span class="tc">24</span> Closing Time</span></p>
<p class="toc"><span href="#/xhtml/chapter25" title="Link target outside of Sample"><span class="tc">25</span> Hangover</span></p>
<p class="toc"> </p>
<p class="toc1"><span href="#/xhtml/bm01" title="Link target outside of Sample"><em>Afterword</em></span></p>
<p class="toc1"><span href="#/xhtml/bm02" title="Link target outside of Sample"><em>Notes</em></span></p>
<p class="toc1"><span href="#/xhtml/bm03" title="Link target outside of Sample"><em>Select Bibliography</em></span></p>
<p class="toc1"><span href="#/xhtml/bm04" title="Link target outside of Sample"><em>Index</em></span></p>
<p class="toc1"><span href="#/xhtml/plates" title="Link target outside of Sample"><em>Picture Section</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?25737e9c